import { ExternalProvider } from '@pressreader/authentication-types';

import { DefaultExternalAuthProvider, InstapaperAuthProvider, registerProvider } from './providers';

registerProvider(ExternalProvider.FACEBOOK, new DefaultExternalAuthProvider());
registerProvider(ExternalProvider.TWITTER, new DefaultExternalAuthProvider());
registerProvider(ExternalProvider.GOOGLE, new DefaultExternalAuthProvider());
registerProvider(ExternalProvider.EVERNOTE, new DefaultExternalAuthProvider());
registerProvider(ExternalProvider.INSTAPAPER, new InstapaperAuthProvider());
registerProvider(ExternalProvider.ONENOTE, new DefaultExternalAuthProvider());
registerProvider(ExternalProvider.BELL, new DefaultExternalAuthProvider());
registerProvider(ExternalProvider.PIANO, new DefaultExternalAuthProvider());
registerProvider(ExternalProvider.OPENIDCONNECT, new DefaultExternalAuthProvider());
registerProvider(ExternalProvider.SAML, new DefaultExternalAuthProvider());
registerProvider(ExternalProvider.APPLE, new DefaultExternalAuthProvider());
registerProvider(ExternalProvider.AUTH0, new DefaultExternalAuthProvider());
